import React, { useState } from "react";
import type { FormCaptureInputProps } from "./types";
import Camera, { FACING_MODES } from "react-html5-camera-photo";
import { Button } from "react-bootstrap";
import toast from "react-hot-toast";
import Modal from "../Modal/Modal";
import { Dialog } from "@mui/material";
import "react-html5-camera-photo/build/css/index.css";
import { IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useUploadAssetMutation } from "redux/services/project";
import { Loader } from "../Loader";
import { dataURItoBlob } from "./utils";
import "./FormCaptureInput.scss";
import { useTranslation } from "react-i18next";

export const FormCaptureInput: React.FC<FormCaptureInputProps> = ({
    images = [],
    label,
    limit,
    error,
    path,
    required,
    disabled,
    onCapture,
    onDelete,
}) => {
    const { t } = useTranslation();
    const [showCamera, setShowCamera] = useState(false);
    const [uploadAsset, { isLoading: uploading }] = useUploadAssetMutation();
    const [selectedImage, setSelectedImage] = useState("");
    const handleClick = () => setShowCamera(true);

    const handleTakePhoto = async (data: string) => {
        setShowCamera(false);
        const formData = new FormData();
        formData.append("file", dataURItoBlob(data));
        formData.append("path", path);

        const uploadRes: any = await uploadAsset(formData);

        if (uploadRes?.data?.url) {
            setTimeout(() => onCapture(uploadRes.data.url), 5000);
            onCapture(
                "https://t3.ftcdn.net/jpg/05/14/75/82/360_F_514758236_i8rnB85PVdEaK19yGaK0TpaYEYMyxOL5.jpg"
            );
        } else {
            toast.error(uploadRes.error.data.message || "Something went wrong");
        }
    };
    const handleCameraError = () => {
        toast.error("You need to give permission to capture when asked");
        setShowCamera(false);
    };

    const handleCloseModal = () => setShowCamera(false);

    const getCloseClickHandler = (index: number) => () => {
        const newImages = [...images];
        newImages.splice(index, 1);

        onDelete?.(newImages);
    };

    const handleCloseImageDialog = () => setSelectedImage("");
    const getImageClickHandler = (img: string) => () => setSelectedImage(img);

    return (
        <div className="form-capture-input">
            <div className="d-flex  flex-column">
                {label && (
                    <label className="form-label">
                        {label}
                        {required && <span>*</span>}
                    </label>
                )}
                <div className="d-flex justify-center align-items-start flex-wrap position-relative">
                    <Button
                        disabled={
                            images.length === limit || disabled || uploading
                        }
                        onClick={handleClick}
                    >
                        {uploading && <Loader />}
                        {t("btn_take_photo")}
                    </Button>
                    <div className="d-flex">
                        {images.map((data, i) => (
                            <div
                                key={i}
                                className="d-flex flex-wrap image-container"
                            >
                                <img
                                    src={data}
                                    alt=""
                                    onClick={getImageClickHandler(data)}
                                />
                                <IconButton
                                    className="close-btn"
                                    disabled={disabled}
                                    hidden={disabled}
                                    onClick={getCloseClickHandler(i)}
                                >
                                    <Close />
                                </IconButton>
                            </div>
                        ))}
                    </div>
                </div>
                {error && (
                    <span className="error-text">
                        {typeof error === "object" ? error.join(", ") : error}
                    </span>
                )}
            </div>

            <Modal
                title="Take Photo"
                modalClassName="capture-photo-modal"
                show={showCamera}
                onClose={handleCloseModal}
                onBackDropClick={handleCloseModal}
                onSubmit={() => {}}
                submitBtnText=""
                cancelBtnText=""
            >
                <Camera
                    imageType="png"
                    sizeFactor={0.5}
                    idealFacingMode={FACING_MODES.ENVIRONMENT}
                    isImageMirror={false}
                    isDisplayStartCameraError={false}
                    onTakePhoto={handleTakePhoto}
                    onCameraError={handleCameraError}
                />
            </Modal>
            <Dialog
                className="captured-image-dialog"
                open={selectedImage.length > 0}
                onClose={handleCloseImageDialog}
            >
                {" "}
                <img
                    className="captured-image"
                    alt="captured"
                    src={selectedImage}
                />{" "}
            </Dialog>
        </div>
    );
};
